import { render, staticRenderFns } from "./transporter.vue?vue&type=template&id=4aecac4b&"
import script from "./transporter.vue?vue&type=script&lang=js&"
export * from "./transporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports